export default __webpack_public_path__ + "static/media/banner-logo.2a690c19.png";